import { render, staticRenderFns } from "./BrandsFilters.vue?vue&type=template&id=3a2c1b78&"
import script from "./BrandsFilters.vue?vue&type=script&lang=js&"
export * from "./BrandsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports